import { render, staticRenderFns } from "./ds-table.vue?vue&type=template&id=03bab4ee&scoped=true&"
import script from "./ds-table.vue?vue&type=script&lang=ts&"
export * from "./ds-table.vue?vue&type=script&lang=ts&"
import style0 from "./ds-table.vue?vue&type=style&index=0&id=03bab4ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03bab4ee",
  null
  
)

export default component.exports